export const asIs = (value) => value;

export const toInteger = (value) => {
  if (value == null) return;

  const trimmedVal = value.trim();
  if (trimmedVal === '') return;

  const num = Number(trimmedVal);

  return Number.isFinite(num) && Number.isInteger(num) && num >= 0
    ? num
    : undefined;
};

export const toIntegerArray = (value) => {
  if (value == null) return;

  const result = value.split(',').reduce((acc, v) => {
    const n = toInteger(v);
    if (n !== undefined) acc.push(n);
    return acc;
  }, []);

  return result.length ? result : undefined;
};

export const toYesNo = (value) => {
  if (value == null) return;

  const trimmedVal = value.trim();
  if (['y', 'n'].includes(trimmedVal)) return trimmedVal;
};

export const yesNoToBoolean = (value) => {
  const normalizedValue = toYesNo(value);
  return normalizedValue === 'y';
};

export const hasValue = (value, normalizer) => normalizer(value) !== undefined;
